<div class="flex flex-column gap-3" data-test="ui-ql-json-view">

    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
        <div class="flex align-items-center gap-2">
            <p-toggleSwitch inputId="uiQlJsonEdit" [ngModel]="editing" (ngModelChange)="onEditingChange($event)"
                            data-test="ui-ql-json-edit-toggle"></p-toggleSwitch>
            <label for="uiQlJsonEdit" class="font-medium">Bearbeiten</label>
        </div>
        <div class="flex align-items-center gap-2">
            <p-button label="Kopieren" icon="fa-regular fa-copy" severity="secondary" [outlined]="true" size="small"
                      [disabled]="!(editing ? editText : json)" (onClick)="copy()"></p-button>
            @if (editing) {
                <p-button label="JSON → Builder" icon="fa-regular fa-arrow-right-to-bracket" size="small"
                          [disabled]="!editText.trim()" data-test="ui-ql-json-apply"
                          (onClick)="applyJson()"></p-button>
            }
        </div>
    </div>

    @if (!editing) {
        @if (json) {
            <pre class="ui-ql-json-view-code overflow-x-auto m-0 p-3 surface-50 border-1 surface-border border-round-lg"
                 data-test="ui-ql-json-code">{{ json }}</pre>
        } @else {
            <p-message severity="info" styleClass="w-full">
                <div class="flex flex-column gap-1">
                    <span class="font-semibold">Noch keine QL-Definition.</span>
                    <span>Wählen Sie im Builder eine Start-Entität oder schalten Sie „Bearbeiten“ ein, um JSON einzufügen.</span>
                </div>
            </p-message>
        }
    } @else {
        <textarea pTextarea class="ui-ql-json-view-editor w-full" rows="24" spellcheck="false"
                  [ngModel]="editText" (ngModelChange)="onEditTextChange($event)"
                  aria-label="QL-Definition als JSON"
                  data-test="ui-ql-json-editor"></textarea>
        <span class="text-sm text-color-secondary">
            „JSON → Builder“ übernimmt die Definition nur vollständig. Teile, die der Builder nicht abbilden kann,
            und Regelverstöße werden unten gemeldet und nicht übernommen.
        </span>
        @if (staleDefinition) {
            <p-message severity="warn" styleClass="w-full" data-test="ui-ql-json-stale">
                <div class="flex flex-wrap align-items-center justify-content-between gap-2 w-full">
                    <span>Definition hat sich geändert – der Text hier ist nicht mehr aktuell.</span>
                    <p-button label="Text neu laden" icon="fa-regular fa-rotate-right" size="small" severity="secondary"
                              [outlined]="true" data-test="ui-ql-json-reload"
                              (onClick)="reloadText()"></p-button>
                </div>
            </p-message>
        }
    }

    @if (result; as r) {
        @if (r.parseError) {
            <p-message severity="error" styleClass="w-full" [text]="r.parseError" data-test="ui-ql-json-parse-error"
                       [pTooltip]="r.parseErrorDetail ?? ''" tooltipPosition="bottom"></p-message>
        }
        @if (r.unmappable.length) {
            <p-message severity="error" styleClass="w-full" data-test="ui-ql-json-unmappable">
                <div class="flex flex-column gap-2">
                    <span class="font-semibold">Nicht abbildbar – die Definition wurde nicht übernommen:</span>
                    <ul class="m-0 pl-3 flex flex-column gap-1">
                        @for (message of r.unmappable; track $index) {
                            <li>{{ message }}</li>
                        }
                    </ul>
                </div>
            </p-message>
        }
        @if (r.violations.length) {
            <p-message severity="error" styleClass="w-full" data-test="ui-ql-json-violations">
                <div class="flex flex-column gap-2">
                    <span class="font-semibold">Regelverstöße – die Abfrage wird nicht ausgeführt:</span>
                    <ul class="m-0 pl-3 flex flex-column gap-1">
                        @for (violation of r.violations; track $index) {
                            <li>
                                {{ violationText(violation) }}
                                <span class="text-sm text-color-secondary ml-1">({{ violation.code }} · {{ violation.path }})</span>
                            </li>
                        }
                    </ul>
                </div>
            </p-message>
        }
    }

    @if (applied) {
        <p-message severity="success" styleClass="w-full" text="Die Definition wurde in den Builder übernommen."
                   data-test="ui-ql-json-applied"></p-message>
    }
</div>
